import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isAnyFilterSelected"];
import { useCallback, useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { FILTER_TYPES } from 'academy-common-lib/constants/TopFilterConstants';
import { PAGE_SIZE } from 'academy-common-lib/features/pagination/paginationConsts';
import { usePagination } from '../../pagination/paginationHooks';
import ApiError from '../../../components/Errors/ApiError';
import PaginatedUICardGrid from '../../../containers/MyLearningPage/PaginatedUICardGrid';
import { useWatchLater } from '../watchLaterQueries';
import { unwrapHubHttpError } from 'academy-common-lib/utils/DataFetchingClient';
import BlankPageMediaWrapper from '../../../components/BlankPageMediaWrapper';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import NoResultsError from '../../../components/Errors/NoResultsError';
import { useLocation } from 'quartz-routing/react-router';
import LearningContentCard from 'academy-common-lib/features/learningContentCard/components/LearningContentCard';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from 'academy-common-lib/hooks/searchParamHooks';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import getLang from 'academy-common-lib/utils/getLang';
import { useDisplayedData } from '../../table/tableHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { SCREENS } from '../../../constants/Tracking.migrated';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { PageResultsCount, PageResultsCountPlaceholder } from 'academy-common-lib/features/header/components/PageResultsCount';
import { FiltersCard } from 'academy-common-lib/features/filters/components/FiltersCard';
import { CertificationsFilter } from 'academy-common-lib/features/filters/components/CertificationsFilter';
import { PageHeader } from '../../header/components/PageHeader';
import { AllContentTypesFilter } from 'academy-common-lib/features/filters/components/AllContentTypesFilter';
import I18n from 'I18n';
import { SearchFilter } from 'academy-common-lib/features/filters/components/SearchFilter';
import { MobileFilterButton } from '../../filters/components/MobileFilterButton';
import { DurationFilter } from 'academy-common-lib/features/filters/components/DurationFilter';
import { scrollPageToTop } from 'academy-common-lib/utils/scrolling';
import { DropdownContentSourceFilter } from 'academy-common-lib/features/filters/components/DropdownContentSourceFilter';
import ErrorBoundary from '../../../components/Errors/ErrorBoundary';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WATCH_LATER_FILTERS = [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.CONTENT_TYPE, FILTER_TYPES.DURATION, FILTER_TYPES.SEARCH, FILTER_TYPES.CONTENT_SOURCE];
const ItemRightComponent = props => {
  return /*#__PURE__*/_jsx(Pictogram, Object.assign({
    inlineSize: "100%",
    name: "EmptyStateSearch"
  }, props));
};
const WatchLaterNoResults = () => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "WATCH_LATER_NO_RESULTS",
    children: /*#__PURE__*/_jsx(View, {
      "data-test-id": "watch-later-empty",
      marginBlockEnd: "400",
      marginBlockStart: isMobile ? '600' : '1000',
      children: /*#__PURE__*/_jsxs(BlankPageMediaWrapper, {
        itemRightComponent: ItemRightComponent,
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.savedItems.favorites.emptyHeading"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.savedItems.favorites.emptyBodyIntro"
          })
        }), /*#__PURE__*/_jsxs(List, {
          ordered: true,
          styled: true,
          children: [/*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.savedItems.favorites.emptyBodyStep1"
            })
          }), /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "learningCenter.savedItems.favorites.emptyBodyStep2"
            })
          }), /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "learningCenter.savedItems.favorites.emptyBodyStep3"
            })
          })]
        })]
      })
    })
  });
};
const WatchLaterNoResultsWithFilter = () => {
  const location = useLocation();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "WATCH_LATER_NO_RESULTS",
    children: /*#__PURE__*/_jsx(NoResultsError, {
      resetLink: location.pathname
    })
  });
};
const WatchLaterResults = ({
  totalCount,
  cardModels,
  displayedCardModels
}) => {
  const {
    currentPage,
    setPage
  } = usePagination();
  const {
    isTablet
  } = useMediaQuery();
  const isGhost = useCallback(item => !!cardModels && !cardModels.some(c => c.id === item.id && c.type === item.type), [cardModels]);
  const handlePageChange = pageNumber => {
    setPage(pageNumber);
    scrollPageToTop();
  };
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "WATCH_LATER_LOADED",
    children: /*#__PURE__*/_jsx(PaginatedUICardGrid, {
      isLoadingPageOnDemand: true,
      limit: PAGE_SIZE,
      onPageChange: handlePageChange,
      page: currentPage,
      shouldRenderOneColumn: isTablet,
      totalCount: totalCount,
      children: displayedCardModels.map(item => /*#__PURE__*/_jsx(LearningContentCard, {
        isGhost: isGhost(item),
        item: item,
        overviewType: "watch-later",
        size: isTablet ? 'small' : 'large'
      }, `item_${item.id}`))
    })
  });
};
const useWatchLaterParams = () => {
  const {
    search
  } = useLocation();
  const urlParams = new URLSearchParams(search);
  const isAnyFilterSelected = WATCH_LATER_FILTERS.some(filter => urlParams.has(filter));
  const {
    currentPage
  } = usePagination();
  const [[searchTerm]] = useSearchParam(FILTER_TYPES.SEARCH);
  const [durationFilters] = useSearchParam(FILTER_TYPES.DURATION);
  const [contentTypes] = useSearchParam(FILTER_TYPES.CONTENT_TYPE);
  const [[awardType]] = useSearchParam(FILTER_TYPES.AWARD_TYPE);
  const [[contentSource]] = useSearchParam(FILTER_TYPES.CONTENT_SOURCE);
  return {
    isAnyFilterSelected,
    currentPage,
    searchTerm,
    durationFilters,
    contentTypes,
    awardType,
    visibilityGroup: contentSource
  };
};
const useWatchLaterList = () => {
  const _useWatchLaterParams = useWatchLaterParams(),
    {
      isAnyFilterSelected
    } = _useWatchLaterParams,
    watchLaterParams = _objectWithoutPropertiesLoose(_useWatchLaterParams, _excluded);
  const {
    currentPage,
    searchTerm,
    durationFilters,
    contentTypes,
    awardType,
    visibilityGroup
  } = watchLaterParams;
  const {
    data,
    loading: watchLaterLoading,
    error
  } = useWatchLater({
    searchTerm,
    hasCertification: awardType === 'ONLY_SHOW_CERTIFICATE_COURSES',
    contentTypes: contentTypes.map(type => type === 'COURSE' ? 'TRACK' : type),
    visibilityGroup,
    durationFilters,
    pageLength: PAGE_SIZE,
    offset: {
      cursor: (currentPage - 1) * PAGE_SIZE
    }
  });
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError,
    userProgressDataLoading
  } = useLearningContentCardModels({
    items: (data === null || data === void 0 ? void 0 : data.results.map(item => {
      const {
        id,
        type
      } = item;
      return {
        id: id,
        type: type,
        language: getLang().toUpperCase() // watch later items don't have language
      };
    })) || [],
    skip: !(data !== null && data !== void 0 && data.results.length)
  });
  const loading = watchLaterLoading || cardModelsLoading || userProgressDataLoading;
  const {
    cardModels: displayedCardModels,
    totalCount: displayedTotalCount = 0
  } = useDisplayedData({
    cardModels,
    totalCount: data === null || data === void 0 ? void 0 : data.total
  }, {
    loading,
    parameters: watchLaterParams,
    initialOnly: true
  }) || {};
  return {
    cardModels,
    displayedTotalCount,
    displayedCardModels,
    loading: loading || !displayedCardModels,
    error: unwrapHubHttpError(error) || cardModelsError,
    currentPage,
    isAnyFilterSelected
  };
};
export const WatchLaterList = () => {
  const {
    cardModels,
    displayedCardModels,
    displayedTotalCount,
    currentPage,
    loading,
    error,
    isAnyFilterSelected
  } = useWatchLaterList();
  const {
    isMobile
  } = useMediaQuery();
  useEffect(() => {
    UsageTracker.trackStandalone('Pageview', {
      screen: SCREENS.WATCH_LATER
    });
  }, []);
  const showFiltersCard = (displayedCardModels === null || displayedCardModels === void 0 ? void 0 : displayedCardModels.length) !== 0 || isAnyFilterSelected;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PageHeader, {
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingSubTitles.WATCH_LATER"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingTitles.WATCH_LATER"
      })
    }), !isMobile && /*#__PURE__*/_jsxs(_Fragment, {
      children: [!loading ? /*#__PURE__*/_jsx(PageResultsCount, {
        page: currentPage - 1,
        pageSize: PAGE_SIZE,
        total: displayedTotalCount
      }) : /*#__PURE__*/_jsx(PageResultsCountPlaceholder, {}), showFiltersCard && /*#__PURE__*/_jsxs(FiltersCard, {
        children: [/*#__PURE__*/_jsx(SearchFilter, {
          appearsIn: "watch-later",
          marginInlineEnd: "600",
          maxInlineSize: "300px",
          placeholder: I18n.text('learningCenter.watchLater.searchPlaceholder')
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myLearning.filterBy"
        }), /*#__PURE__*/_jsx(CertificationsFilter, {
          appearsIn: "watch-later"
        }), /*#__PURE__*/_jsx(AllContentTypesFilter, {
          appearsIn: "watch-later",
          excludeTypes: ['LEARNING_PATH']
        }), /*#__PURE__*/_jsx(DropdownContentSourceFilter, {
          appearsIn: "watch-later"
        }), /*#__PURE__*/_jsx(DurationFilter, {
          appearsIn: "watch-later"
        })]
      })]
    }), isMobile && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(TFlex, {
        alignItems: "center",
        gap: 16,
        marginBlockEnd: "600",
        children: [/*#__PURE__*/_jsx(SearchFilter, {
          appearsIn: "watch-later",
          placeholder: I18n.text('learningCenter.watchLater.searchPlaceholder')
        }), /*#__PURE__*/_jsx(MobileFilterButton, {
          mobileFilterTypes: WATCH_LATER_FILTERS,
          totalCount: displayedTotalCount
        })]
      }), !loading && /*#__PURE__*/_jsx(PageResultsCount, {
        page: currentPage - 1,
        pageSize: PAGE_SIZE,
        total: displayedTotalCount
      })]
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      boundaryName: "WatchLaterContent",
      children: error ? /*#__PURE__*/_jsx(ApiError, {
        error: error,
        marker404: "WATCH_LATER_API_404",
        markerDefault: "WATCH_LATER_API_ERROR"
      }) : loading && !displayedCardModels ? /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        minHeight: 100
      }) : displayedCardModels !== null && displayedCardModels !== void 0 && displayedCardModels.length ? /*#__PURE__*/_jsx(WatchLaterResults, {
        cardModels: cardModels,
        displayedCardModels: displayedCardModels,
        totalCount: displayedTotalCount
      }) : isAnyFilterSelected ? /*#__PURE__*/_jsx(WatchLaterNoResultsWithFilter, {}) : /*#__PURE__*/_jsx(WatchLaterNoResults, {})
    })]
  });
};